export default {
  terms:
    'Door je bestelling te plaatsen, ga je akkoord met onze <TermsLink>Algemene Voorwaarden</TermsLink> en ons <PrivacyPolicyLink>Privacybeleid</PrivacyPolicyLink>.',
};
